import { HeadContent, Outlet, createRootRoute } from '@tanstack/react-router'
import { NotFoundPage } from '@/pages/ErrorPages'

export const Route = createRootRoute({
  // Default document title; each route overrides it via its own `head` (deepest title wins).
  // <HeadContent /> applies the matched route's title to document.title on every navigation, so
  // browser history records a meaningful name per page instead of a single static "AERRIS".
  head: () => ({ meta: [{ title: 'AERRIS' }] }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  notFoundComponent: NotFoundPage,
})
